import { api } from '../api/client';

/**
 * Fetch a server endpoint that sends raw JSON (via @Res, not the JSON envelope) and save it as a
 * .json file. Uses `api` (raw axios) with responseType 'text' so the body is the exact JSON string,
 * not an unwrapped object — the file round-trips byte-for-byte back through the import endpoint.
 */
export async function downloadJson(url: string, filename: string): Promise<void> {
  const r = await api.get(url, { responseType: 'text' });
  const body = typeof r.data === 'string' ? r.data : JSON.stringify(r.data, null, 2);
  const blob = new Blob([body], { type: 'application/json;charset=utf-8' });
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    URL.revokeObjectURL(objectUrl);
    a.remove();
  }, 100);
}
